import React, { useState, useEffect } from 'react';
import { GetSalesTeams } from '../CampaignBriefLookupService';
import AsSelectWithPlaceholder from '../../../generic/AsSelectWithPlaceholder';
import { GetUser } from '../../../../services/DataService';
import { EmptyGuid } from '../../../../constants/Enums';
import { isAuthorised } from '@adserve/adserve-react-components';

const CampaignSalesTeam = ({ campaign, onChange, readOnly, editAuthorisedOnly }) => {

    const [salesTeamList, setSalesTeamList] = useState([]);
    const [salesTeamId, setSalesTeamId] = useState('')

    useEffect(() => {
        GetSalesTeams().then((teams) => {
            teams.data.data.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
            setSalesTeamList(teams.data.data);
        });

    }, []);
    
    useEffect(() => {
        setSalesTeamId(campaign?.salesTeamId ?? '')
    }, [campaign])
 

    useEffect(() => {

        if (campaign.id === EmptyGuid) {
            GetUser(campaign?.salesExecId).then((user) => {
                const currentUserSalesTeam = salesTeamList.find((x) => x.id === user.salesTeamId);
                setSalesTeamId(currentUserSalesTeam.id)
                onChange(currentUserSalesTeam.id)
            });
        }
        
    }, [])

    const handleSalesTeamChange = (event) => {
        setSalesTeamId(event.target.value)
        onChange(event.target.value)
    };

    return (
        <div style={{ width: 280 }}>
            <AsSelectWithPlaceholder
                id='user-salesTeamId'
                name='salesTeamId'
                values={salesTeamList}
                value={salesTeamId}
                onChange={handleSalesTeamChange}
                disabled={!isAuthorised('EDIT_BOOKED_CAM') === false ? !editAuthorisedOnly : readOnly}
                title={window.translate('Sales Team')}
            />
        </div>
    );
};

export default CampaignSalesTeam;
